null==Element.prototype.getAttributeNames&&(Element.prototype.getAttributeNames=function(){for(var t=this.attributes,e=t.length,r=new Array(e),n=0;n<e;n++)r[n]=t[n].name;return r});
